import React, { useRef } from "react";
import "./InvoiceDownload.css";

function InvoiceDownload({
  order_id,
  product_name,
  license_key,
  amount_eur,
  paid_at,
  customer_email,
}) {
  const invoiceRef = useRef(null);

  const handleDownload = () => {
    const invoiceEl = invoiceRef.current;
    if (!invoiceEl) return;

    const printWindow = window.open("", "_blank", "width=800,height=600");
    if (!printWindow) {
      alert("Please allow pop-ups to download your invoice.");
      return;
    }

    const invoiceHTML = invoiceEl.outerHTML;

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="utf-8" />
        <title>Invoice ${order_id}</title>
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body {
            font-family: 'Courier New', monospace;
            color: #0D1B2A;
            background: #fff;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          @page {
            size: A4;
            margin: 20mm;
          }
          @media print {
            body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          }
          .invoice {
            max-width: 170mm;
            margin: 0 auto;
            font-size: 11px;
            line-height: 1.6;
          }
          .invoice__header {
            background: #0D1B2A;
            color: #fff;
            padding: 24px 28px;
            border-radius: 4px 4px 0 0;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
          }
          .invoice__brand-name {
            font-size: 20px;
            font-weight: 700;
            letter-spacing: 1px;
            margin-bottom: 4px;
          }
          .invoice__brand-sub {
            font-size: 9px;
            letter-spacing: 2px;
            opacity: 0.7;
          }
          .invoice__brand-domain {
            font-size: 9px;
            opacity: 0.6;
            margin-top: 6px;
          }
          .invoice__brand-email {
            font-size: 9px;
            opacity: 0.6;
          }
          .invoice__meta {
            text-align: right;
            font-size: 9px;
          }
          .invoice__meta-label {
            opacity: 0.6;
            text-transform: uppercase;
            letter-spacing: 1px;
            margin-bottom: 2px;
          }
          .invoice__meta-value {
            font-size: 12px;
            font-weight: 600;
          }
          .invoice__status {
            display: inline-block;
            background: #0D9488;
            color: #fff;
            padding: 3px 10px;
            border-radius: 3px;
            font-size: 8px;
            font-weight: 700;
            letter-spacing: 1px;
            margin-top: 6px;
          }
          .invoice__body {
            border: 1px solid #e2e8f0;
            border-top: none;
            padding: 28px;
            border-radius: 0 0 4px 4px;
          }
          .invoice__section {
            margin-bottom: 24px;
          }
          .invoice__section-title {
            font-size: 8px;
            text-transform: uppercase;
            letter-spacing: 1.5px;
            color: #94a3b8;
            margin-bottom: 12px;
            border-bottom: 1px solid #e2e8f0;
            padding-bottom: 6px;
          }
          .invoice__info-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
          }
          .invoice__info-label {
            font-size: 8px;
            text-transform: uppercase;
            letter-spacing: 1px;
            color: #94a3b8;
          }
          .invoice__info-value {
            font-size: 11px;
            font-weight: 500;
          }
          .invoice__info-value--license {
            font-family: 'Courier New', monospace;
            background: #f1f5f9;
            padding: 2px 8px;
            border-radius: 3px;
            word-break: break-all;
            font-size: 10px;
          }
          .invoice__table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 4px;
          }
          .invoice__table th {
            text-align: left;
            font-size: 8px;
            text-transform: uppercase;
            letter-spacing: 1px;
            color: #94a3b8;
            padding: 10px 0;
            border-bottom: 2px solid #0D1B2A;
          }
          .invoice__table th:last-child {
            text-align: right;
          }
          .invoice__table td {
            padding: 10px 0;
            border-bottom: 1px solid #e2e8f0;
            font-size: 11px;
          }
          .invoice__table td:last-child {
            text-align: right;
            font-weight: 600;
          }
          .invoice__total {
            text-align: right;
            margin-top: 12px;
            font-size: 14px;
            font-weight: 700;
          }
          .invoice__footer {
            margin-top: 32px;
            padding-top: 16px;
            border-top: 1px solid #e2e8f0;
            font-size: 8px;
            color: #94a3b8;
            line-height: 1.8;
          }
          .invoice__footer strong {
            color: #64748b;
          }
        </style>
      </head>
      <body>
        ${invoiceHTML}
        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = function() { window.close(); };
          };
        </script>
      </body>
      </html>
    `);
    printWindow.document.close();
  };

  return (
    <div className="invoice-download">
      <button className="invoice-download__btn" onClick={handleDownload}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
        Download Invoice
      </button>

      {/* Hidden invoice template for print */}
      <div className="invoice-download__hidden" ref={invoiceRef}>
        <div className="invoice">
          <div className="invoice__header">
            <div>
              <div className="invoice__brand-name">AxiomLabs Solutions</div>
              <div className="invoice__brand-sub">SOFTWARE LICENSE INVOICE</div>
              <div className="invoice__brand-domain">axiomlabssolutions.com</div>
              <div className="invoice__brand-email">axiomlabssolutions@gmail.com</div>
            </div>
            <div className="invoice__meta">
              <div className="invoice__meta-label">Invoice</div>
              <div className="invoice__meta-value">{order_id}</div>
              <div className="invoice__meta-label" style={{ marginTop: 6 }}>
                Date
              </div>
              <div className="invoice__meta-value">{paid_at}</div>
              <div className="invoice__status">PAID</div>
            </div>
          </div>

          <div className="invoice__body">
            <div className="invoice__section">
              <div className="invoice__section-title">Bill To</div>
              <div className="invoice__info-value">{customer_email}</div>
            </div>

            <div className="invoice__section">
              <div className="invoice__section-title">Order Details</div>
              <table className="invoice__table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{product_name}</td>
                    <td>€{amount_eur?.toLocaleString?.() || amount_eur}</td>
                  </tr>
                </tbody>
              </table>
              <div className="invoice__total">
                Total: €{amount_eur?.toLocaleString?.() || amount_eur}
              </div>
            </div>

            {license_key && (
              <div className="invoice__section">
                <div className="invoice__section-title">License Key</div>
                <div className="invoice__info-value invoice__info-value--license">
                  {license_key}
                </div>
              </div>
            )}

            <div className="invoice__footer">
              <p>
                Thank you for your purchase. This license is issued to{" "}
                <strong>{customer_email}</strong>.
              </p>
              <p>
                For support: <strong>axiomlabssolutions@gmail.com</strong>
              </p>
              <p style={{ marginTop: 8 }}>
                AxiomLabs Solutions — axiomlabssolutions.com
                <br />© {new Date().getFullYear()} Kuteesa Joshua. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InvoiceDownload;
